export const initialState = {
  name: '',
  email: '',
  password: '',
};
